module.exports = __webpack_public_path__ + "src/img/locate.1b82462b.svg";